import { render } from "./CompletedCrisisDocument.vue?vue&type=template&id=26c2ace5&scoped=true"
import script from "./CompletedCrisisDocument.vue?vue&type=script&lang=js"
export * from "./CompletedCrisisDocument.vue?vue&type=script&lang=js"

import "./CompletedCrisisDocument.vue?vue&type=style&index=0&id=26c2ace5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c2ace5"]])

export default __exports__